
<script>

export default {
  props: {
    bodytitles: { // titles in dropList
      type: Array,
      default: () => []
    }
  },
  components: {
  },
  mounted () {
  },
  data () {
    return {
      currentindex: 0
    }
  },
  computed: {
  },
  methods: {
    changeState: function (index) {
      let state = !this.bodytitles[index].state
      this.bodytitles[index].state = state
      this.$set(this.bodytitles, index, this.bodytitles[index])
      this.currentindex = index
      this.$emit('currentindex', this.currentindex)
    }
  }
}

</script>

<template>
   <div class="row clearfix ">
<div class="col-md-8 column tablediv scrollbar" >
                <div v-for="(title,index) in bodytitles" :key="index">
                    <div class=" panel panel-default  option-record" @click="changeState(index)">
                        <div class="panel-heading" >
                            <h3 class="panel-title">
                                {{bodytitles[index].title}}
                            </h3>
                              <span class="arrow"
                                  :class="bodytitles[index].state ? 'triangle' : 'trianglebottom' ">
                            </span>
                        </div>
                    </div>

                    <div  v-show="title.state">
                       <slot name="spreadtable"> </slot>
                    </div>
                </div>
        </div>
     </div>
</template>

<style lang="scss" scoped>
 .tablediv {
  height: 500px;
  width: 80%;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-left: 150px;
}

.tablecss {
  width: 94.3%;
  margin-left: 50px;
  height: 100px;
  border: 1.5px solid rgb(155, 155, 155);
  margin-top: -2px;
  background-color: white;
}

.scrollbar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.scrollbar::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
  box-shadow: none;
}
.scrollbar::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
  box-shadow: none;
}

.option-record {
  margin: 20px 20px 0px 50px;
}

.panel-default > .panel-heading {
  background: #797979;
  text-align: left;
  vertical-align: center;
}
.panel-title {
  font-size: 18px;
  color: #fff;
  height: 27px;
  vertical-align: 50%;
  padding-top: 5px;
  padding-left: 10px;
}

/* 箭头 */
.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  // float: right;
  margin-right: 30px;
  /* margin-top调整上下位置 */
  margin-top: -23px;
  opacity: 0.66;
  color: #757575;
}

.arrow.triangle {
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  height: 14px;
  width: 14px;
  transform: none;
  -webkit-transform: rotate(225deg);
  border-left: 2px solid transparent;
  border-top: 2px solid transparent;
}

.arrow.trianglebottom {
  border-left: 2px solid white;
  border-top: 2px solid white;
  height: 14px;
  width: 14px;
  transform: none;
  -webkit-transform: rotate(225deg);
  border-right: 2px solid transparent;
  border-bottom: 2px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/dropList.vue